import { Provider } from 'mobx-react';
import React from 'react';
import mainStore from './mobx/mainStore';
import { GoogleMapsProvider } from './utils/GoogleMapsProvider';
import Routers from './view/routers';

const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
// 'drawing' was removed: Google deprecated the Drawing library (DrawingManager) from the
// Maps JavaScript API in Aug 2025 and removed it in May 2026. Polygon drawing for delivery
// zones is now implemented manually in DeiveryZoneDrawingTools.
const googleMapsLibraries: ('places' | 'geometry' | 'localContext' | 'visualization')[] = ['places', 'geometry'];

export default class App extends React.Component<{}> {
  public render() {
    return (
      <Provider {...mainStore}>
        <GoogleMapsProvider googleMapsApiKey={googleMapsApiKey} language="en" libraries={googleMapsLibraries}>
          <Routers />
        </GoogleMapsProvider>
      </Provider>
    );
  }
}
